import {
  compose,
  withHandlers,
  setDisplayName,
  branch,
  renderComponent,
  renderNothing,
  lifecycle,
} from 'recompose';
import { connect } from 'react-redux';
import { get } from 'lodash';
import CheckoutModal from './CheckoutModal';
import { ValidateAppointmentContainer } from './ValidateAppointment';
import {
  canBeChargedWithSavedCard,
  getAppointmentId,
  getActiveTipAmount,
  getPromoCode,
  isAppointmentPaid,
} from '../selectors';
import { chargeAppointment, fetchReservation } from '../actions';
import AppointmentPaidModal from '../components/AppointmentPaidModal';

export default compose(
  setDisplayName('CheckoutContainer'),
  ValidateAppointmentContainer,
  connect((state, ownProps) => ({
    tipAmount: getActiveTipAmount(state, ownProps.serviceId),
    promoCode: getPromoCode(state),
    appointmentId: getAppointmentId(state),
    isAppointmentPaid: isAppointmentPaid(state),
    canBeChargedWithSavedCard: canBeChargedWithSavedCard(state),
    isReservation: !!get(ownProps, 'location.query.isReservation'),
  }), { chargeAppointment, fetchReservation }),
  lifecycle({
    componentDidMount() {
      this.props.fetchReservation(this.props.params.appointmentId);
    },
  }),
  branch(props => !props.appointmentId, renderNothing),
  branch(props => props.isAppointmentPaid, renderComponent(AppointmentPaidModal)),
  withHandlers({
    onSuccess: props => (paymentToken, chargeWithSavedCard) => props.chargeAppointment(props.appointmentId, {
      tipAmount: props.tipAmount,
      promoCode: props.promoCode,
      chargeWithSavedCard,
      ...(props.isReservation ? { isReservation: true } : {}),
      ...(paymentToken ? { paymentToken: paymentToken.id } : {}),
    }),
  })
)(CheckoutModal);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/CheckoutContainer.js